import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import UOMConversion from '../../../../components/UOMConversion';

const UOMUI = React.memo(
    ({ UOMProductDetails, ProductUOM, updateChoosingUOM }) => {

        const [SelectedUOM, setSelectedUOM] = useState({ id: 0, UOM: ProductUOM });
        const [ListUOMs, setListUOMs] = useState({ Status: "Loading", Data: [] });

        useEffect(() => {

            let addId = JSON.parse(UOMProductDetails).map((data, index) => ({
                ...data, id: index + 1
            }))
            addId = [{ id: 0, UOM: ProductUOM }, ...addId]
            // addId = [{ id: 0, UOM: ProductUOM }, ...addId,{
            //     "unitCode": "EA",
            //     "CorrespondingQuantity": "1.00000000000000",
            //     "Quantity": "10",
            //     "CorrespondingQuantityTypeCode": "XBX",
            //     "id": 3
            // }]
            setListUOMs({ Status: "Loaded", Data: addId })
        }, [UOMProductDetails, ProductUOM])

        const handleUOM = (data) => {
            setSelectedUOM(data);
            updateChoosingUOM(data);
        }


        return (
            <div className='flex flex-wrap gap-3'>
                {ListUOMs.Data.map((data) => (
                    <div key={data.id} className={` ${data?.id === SelectedUOM.id ? "border-2 border-blue-500 text-center " :
                        "border-1 border-black hover:border-blue-500 "} border-round-md cursor-pointer`}>

                        <Button onClick={() => handleUOM(data)}
                            className={`${data?.id === SelectedUOM.id ? "text-blue-500 font-semibold" : "text-black hover:text-blue-500"} capitalize`} >
                            <i className={` ${data?.id === SelectedUOM.id ? 'pi pi-check pr-1  ' : ''}`}
                                style={{ fontSize: '0.7rem' }}></i>

                            {data.id === 0 ? (<UOMConversion UOMCode={data.UOM} />) :
                                <div>
                                    {`${parseInt(data.CorrespondingQuantity)} `}<UOMConversion UOMCode={data.CorrespondingQuantityTypeCode} />
                                    {`= ${parseInt(data.Quantity)} `}<UOMConversion UOMCode={data.unitCode} />
                                </div>}
                        </Button>

                    </div>
                ))}
            </div>
        )
    }
)

export default UOMUI